import carousel from './carousel';

const heroSlideshow = document.querySelector('.HeroSlideshow-swiper');

(function initSwiper(slide) {
  const speed = heroSlideshow.dataset.slideshowSpeed || '6';
  const count = heroSlideshow.dataset.slideshowCount || 2;
  carousel(
    slide,
    {
      autoHeight: true,
      loop: count > 1,
      loopedSlides: count > 1 ? 50 : 1,
      autoplay:
        count > 1
          ? {
              delay: parseInt(speed, 10) * 1000,
            }
          : false,
      disableOnInteraction: true,
    },
    false
  );
})(heroSlideshow);
